<div *ngIf="isUsingLatestSaffron; else usingLegacy" class="my-application-card-container">
	<staff-saf-card *ngFor="let app of filteredApplications" class="application-card" appearance="vertical"
		heading-level="2" image-bleed="true" density="inherit">
		<div>
			<staff-saf-anchor (click)="app.getUrl()">{{app.name | translate}}</staff-saf-anchor>
			<staff-saf-icon (click)="app.getUrl()" icon-name="arrow-up-right-from-square" filled="false"
				presentation="false"
				[attr.alt]="'Onvio.Dashboard.MyApplications.OpensNewTab' | translate"></staff-saf-icon>
		</div>
	</staff-saf-card>
</div>
<ng-template #usingLegacy>
	<div class="widget-container">
		<div *ngFor="let app of filteredApplications" [bentoBusyLoader]="app.loader" (click)="app.getUrl()"
			class="application-box">
			<a class="new-tab-icon bento-icon-newtab"></a>
			<p class="application-name">{{app.name}}</p>
		</div>
	</div>
</ng-template>